import React, { Fragment } from 'react'
import styled from 'styled-components'
import { MediumScreenUp, Container } from '../../utils/style'
import { Box } from 'rebass'
import buildPath from '../../../lib/cars/used/path-builder.js'

const Wrapper = styled(Box)`
  position: relative;
  background-color: ${(props) => props.theme.colors.blue_light};
  z-index: 20;
  a {
    color: ${(props) => props.theme.colors.grey_op65};
  }
`

class Breadcrumbs extends React.PureComponent {
  render() {
    const categoryPath = buildPath(this.props.category, false, true)
    const brandPath = buildPath(
      this.props.category,
      Object.assign({}, this.props.vehicle, { registration: '', model: '' })
    )
    const modelPath = buildPath(
      this.props.category,
      Object.assign({}, this.props.vehicle, { registration: '' })
    )
    const categoryText = `${this.props.category[0].toUpperCase()}${this.props.category.substring(
      1
    )}s`

    const type = 'Used '

    return (
      <div key="breadcrumbs">
        <MediumScreenUp>
          <Wrapper width={12 / 12} pt={[10, null, 10]} pb={[10, null, 10]}>
            <Container px={20} maxWidth={'100%'} id={this.props.id}>
              <a href={categoryPath}>
                {type} {categoryText}
              </a>
              <span> &#62; </span>
              <a href={brandPath}>{this.props.vehicle.brand}</a>
              {this.props.vehicle.model && (
                <Fragment>
                  <span> &#62; </span>
                  <a href={modelPath}>{this.props.vehicle.model}</a>
                </Fragment>
              )}
            </Container>
          </Wrapper>
        </MediumScreenUp>
      </div>
    )
  }
}

export default Breadcrumbs
